import { createTheme } from "@material-ui/core";
import { aaaCustomColorsDark } from "./aaaCustomColorsDark";

export const aaaThemeDark = createTheme({
    palette: {
        primary: {
            main: aaaCustomColorsDark.primary
        },
        error: {
            main: aaaCustomColorsDark.error
        },
        background: {
            paper: aaaCustomColorsDark.darkSecondary
        },
        action: {
            active: aaaCustomColorsDark.darkForeground
        },
        type: "dark"
    },
    typography: {
        fontFamily: "Inter"
    },
    overrides: {
        MuiButton: {
            containedPrimary: {
                backgroundColor: aaaCustomColorsDark.primary,
                "&:hover": {
                    backgroundColor: aaaCustomColorsDark.primaryDark
                }
            },
            root: {
                textTransform: "none",
                borderRadius: 0,
                padding: "18px 26px 18px 26px"
            }
        },
        MuiChip: {
            root: {
                backgroundColor: aaaCustomColorsDark.darkTertiary
            }
        },
        MuiCheckbox: {
            root: {
                color: aaaCustomColorsDark.darkForeground,
                padding: 0
            },
            colorSecondary: {
                "&.Mui-checked": {
                    color: aaaCustomColorsDark.primary
                }
            }
        },
        MuiFilledInput: {
            root: {
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                backgroundColor: "transparent",
                "&:hover": {
                    backgroundColor: "unset"
                },
                "&.Mui-focused": {
                    backgroundColor: "unset"
                }
            },
            multiline: {
                "&.Mui-focused": {
                    padding: "25px 12px 8px"
                }
            }
        },
        MuiTextField: {
            root: {
                borderRadius: 0,
                backgroundColor: aaaCustomColorsDark.darkTertiary
            }
        },
        MuiInputBase: {
            root: {
                height: 56,
                color: aaaCustomColorsDark.darkForeground,
                "&.Mui-focused": {
                    borderTop: "2px solid transparent",
                    borderBottom: `2px solid ${aaaCustomColorsDark.primary}`
                }
            },
            multiline: {
                height: "auto"
            }
        },
        MuiAutocomplete: {
            inputRoot: {
                paddingTop: "12px !important",
                paddingBottom: 12,
                height: "unset",
                minHeight: 56,
                "&.Mui-focused": {
                    paddingBottom: 10,
                    paddingTop: "10px !important"
                }
            }
        },
        MuiDialog: {
            paper: {
                backgroundColor: aaaCustomColorsDark.darkPrimary
            }
        },
        MuiSelect: {
            icon: {
                fill: aaaCustomColorsDark.primary
            }
        },
        MuiFormLabel: {
            root: {
                color: aaaCustomColorsDark.body1Dark,
                "&.Mui-focused": {
                    color: aaaCustomColorsDark.body1Dark
                }
            },
            colorSecondary: {
                "&.Mui-focused": {
                    color: aaaCustomColorsDark.primary
                }
            }
        },
        MuiListItem: {
            root: {
                "&.Mui-disabled": {
                    opacity: 1
                }
            }
        },
        MuiToolbar: {
            root: {
                "&.MuiPickersToolbar-toolbar": {
                    backgroundColor: aaaCustomColorsDark.darkPrimary
                },
                "& .MuiPickersToolbarText-toolbarTxt": {
                    color: "#ffffff8a"
                },
                "& .MuiPickersToolbarText-toolbarBtnSelected": {
                    color: aaaCustomColorsDark.white
                }
            }
        },
        MuiPickersDay: {
            daySelected: {
                color: aaaCustomColorsDark.white
            }
        },
        MuiPickersClockNumber: {
            clockNumberSelected: {
                color: aaaCustomColorsDark.white
            }
        },
        MuiTab: {
            root: {
                textTransform: "none"
            },
            textColorInherit: {
                opacity: 1,
                color: aaaCustomColorsDark.body1Dark,
                "&.Mui-selected": {
                    color: aaaCustomColorsDark.primary,
                    fontWeight: 700
                }
            }
        },
        MuiTableSortLabel: {
            root: {
                "&.MuiTableSortLabel-active": {
                    color: "unset"
                }
            }
        },
        MuiTableRow: {
            head: {
                backgroundColor: aaaCustomColorsDark.darkSecondary
            }
        },
        MuiSnackbarContent: {
            root: {
                backgroundColor: aaaCustomColorsDark.errorBackground,
                color: aaaCustomColorsDark.error,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: `1px solid ${aaaCustomColorsDark.error}`
            }
        },
        MuiCardContent: {
            root: {
                "&.applicantCardInterviews": {
                    borderTop: `1px solid #5a5a5a`
                }
            }
        },
        MuiTableCell: {
            root: {
                borderBottom: `1px solid ${aaaCustomColorsDark.darkTertiary}`
            }
        }
    }
});
